/**
 * @description : Alert Popup
 * @author : SAR TECH EASY
 * @date : 24-04-2023
 * */

/* Import Components and Functions Here */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AiOutlineWarning } from 'react-icons/ai';
import styles from './popups.module.scss';

function AlertPopup(props) {
  /* Onclick Event will call this Close the Window */
  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <>
      <Modal size="sm" show={props.show} onHide={handleClose} centered>
        <Modal.Body className="text-center">
          <AiOutlineWarning className={styles.alertWarningIcon} />
          <h3>{props.title} </h3>
          {props.description}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="primary" onClick={handleClose}>
            {props.buttonText || ' Close Window'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AlertPopup;
